// extracted by mini-css-extract-plugin
export default {"sidebar":"SideBar_sidebar__BAaMW","sidebar_section":"SideBar_sidebar_section__3Lh1C"};